module.exports = __webpack_public_path__ + "static/img/rank_234.48eb79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_234.png
// module id = oq7k
// module chunks = 1